// @flow
import React from 'react';
import type { Dispatch } from 'redux';
import type { ComponentType, Element } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import type { State, Actions } from '../store';
import Auth from '../components/Auth';
import { actions as authActions } from '../store/auth';
import parseQueryParams from '../lib/parseQueryParams';

const parseToken = (queryParams) => {
  if (queryParams.token) {
    return { authTokenType: 'email', authToken: queryParams.token };
  }
  if (queryParams.guid) {
    return { authTokenType: 'guid', authToken: queryParams.guid };
  }
  return { authTokenType: null, authToken: null };
};

const mapStateToProps = ({ authReducer }: State, ownProps) => {
  const queryParams = parseQueryParams(ownProps.location.search);
  const { authTokenType, authToken } = parseToken(queryParams);

  return {
    authTokenType,
    authToken,
    session: authReducer.session,
    error: authReducer.error,
    isLoading: false
  };
};
const mapDispatchToProps = (dispatch: Dispatch<Actions>) => ({
  getSession: (authTokenType, authToken) =>
    dispatch(authActions.getSession(authTokenType, authToken))
});
const AuthContainer = compose(connect(mapStateToProps, mapDispatchToProps))(
  Auth
);

export const protect = (
  WrappedComponent: ComponentType<*>
): ComponentType<*> => ({ ...props }): Element<typeof AuthContainer> => (
  <AuthContainer {...props}>
    <WrappedComponent {...props} />
  </AuthContainer>
);
export default AuthContainer;
